import React from 'react';
import { Snackbar } from '@mui/material';
import { LessonBookmarksApi } from './useLessonBookmarks';

export interface BookmarkFeedbackProps {
  bookmarks: LessonBookmarksApi;
}

// The toast pair for a bookmark toggle, shared by the landing grid and the lesson
// detail page so both confirm a toggle identically (QA 2.2 / 3.13). The hook only
// ever holds one of the two at a time.
export default function BookmarkFeedback({ bookmarks }: BookmarkFeedbackProps) {
  const {
    toast, dismissToast, error, dismissError,
  } = bookmarks;
  return (
    <>
      <Snackbar
        open={!!toast}
        autoHideDuration={3000}
        onClose={dismissToast}
        message={toast}
      />
      <Snackbar
        open={!!error}
        autoHideDuration={5000}
        onClose={dismissError}
        message={error}
      />
    </>
  );
}
